import Section from "../../../../components/section";
import { ReactComponent as ArrowBackIcon } from '../../../../assets/icons/arrow-back.svg';
import { useNavigate } from "react-router-dom";
import AddMidPartForm from "./add-mid.part.form";
import './add-mid-page.scss';

const AddMidPage = () => {
    const navigate = useNavigate();

    return (
        <div className="add-mid-page page-content">
            <div className="page-header flex-row flex-gap-20 flex-align-start-center">
                <ArrowBackIcon
                    className="back-icon pointer"
                    onClick={() => navigate(-1)}
                />
                <div className='page-title'>
                    Add MID
                </div>
            </div>
            <Section>
                <AddMidPartForm/>
            </Section>
        </div>
    )
}

export default AddMidPage;